import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

function SvgIconTrash(
  { title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-label="dui_icon"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none">
        <path d="M0 0h24v24H0z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 5h14v17H5z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={2}
          d="M5 2h14M9 10v8M15 10v8"
        />
      </g>
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgIconTrash);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
